/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecordBuyerOrderFromExtensionRequest interface.
 */
export function instanceOfRecordBuyerOrderFromExtensionRequest(value) {
    if (!('externalOrderId' in value) || value['externalOrderId'] === undefined)
        return false;
    if (!('buyerOrderId' in value) || value['buyerOrderId'] === undefined)
        return false;
    return true;
}
export function RecordBuyerOrderFromExtensionRequestFromJSON(json) {
    return RecordBuyerOrderFromExtensionRequestFromJSONTyped(json, false);
}
export function RecordBuyerOrderFromExtensionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'externalOrderId': json['externalOrderId'],
        'buyerOrderId': json['buyerOrderId'],
        'cost': json['cost'] == null ? undefined : json['cost'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'giftCard': json['giftCard'] == null ? undefined : json['giftCard'],
        'promisedDeliveryDate': json['promisedDeliveryDate'] == null ? undefined : (new Date(json['promisedDeliveryDate'])),
    };
}
export function RecordBuyerOrderFromExtensionRequestToJSON(json) {
    return RecordBuyerOrderFromExtensionRequestToJSONTyped(json, false);
}
export function RecordBuyerOrderFromExtensionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'externalOrderId': value['externalOrderId'],
        'buyerOrderId': value['buyerOrderId'],
        'cost': value['cost'],
        'currency': value['currency'],
        'giftCard': value['giftCard'],
        'promisedDeliveryDate': value['promisedDeliveryDate'] == null ? undefined : ((value['promisedDeliveryDate']).toISOString().substring(0, 10)),
    };
}
